<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
  <div class="modal-body">
    <article>
      <h2>Quỹ mở là gì?</h2>
      <p>
        Quỹ mở là quỹ đầu tư được thành lập và quản lý chuyên nghiệp bởi Công Ty Quản Lý Quỹ đã đăng ký và chịu sự giám
        sát của Ủy ban Chứng khoán Nhà nước.
      </p>
      <p>
        Các chuyên gia đầu tư của Công ty Quản lý quỹ sẽ đầu tư có chọn lọc vào cổ phiếu, trái phiếu…nhằm đem lại giá
        trị cho Nhà đầu tư.
      </p>
    </article>

    <article>
      <h2>Fmarket là gì?</h2>
      <p>
        Fmarket là một sản phẩm của <a href="http://fincorp.vn" target="_blank">Công ty Cổ phần Fincorp</a>, giấy ĐKKD
        số 0314127430 do Sở Kế hoạch & Đầu tư TPHCM cấp ngày 23/11/2016.
      </p>
      <p>Fmarket là nền tảng giao dịch Quỹ mở tập trung được UBCK NN cấp Giấy phép vào năm 2018. </p>
    </article>
    <article>
      <h2>Các công ty quản lý quỹ hàng đầu</h2>
      <div class="fund__owner">
        <div class="fund__owner--item" *ngFor="let item of parnters">
          <a [routerLink]="item.link" (click)="dismiss()">
            <img loading="lazy" [src]="item.logoUrl" alt="{{ item.title }}" />
          </a>
        </div>
      </div>
    </article>

    <a target="_blank" (click)="closeModalAndRedirect()">
      <img src="./assets/params/images/background/bg-fmarket-community-resize.webp" alt="cộng đồng Fmarket" />
    </a>
  </div>
</div>